// extracted by mini-css-extract-plugin
export default {"badge":"WY3h5QS7","button":"fSMOITFv dim-button"};